import { DistributionStats } from '@/components/admin/DistributionStats';
import { PairwiseCoverageMatrix } from '@/components/admin/PairwiseCoverageMatrix';
import { UsersAnalyticsTable } from '@/components/admin/UsersAnalyticsTable';
import {
  RecentActivity,
  VotesOverTime,
} from '@/components/admin/UserVotingStats';
import { EvalLayout } from '@/components/eval/EvalLayout';

export default function UserStatsPage() {
  return (
    <EvalLayout>
      <div className="space-y-8">
        <div>
          <h1
            className="font-serif text-3xl font-semibold mb-2"
            style={{ color: '#1A1A1A' }}
          >
            Users Analytics
          </h1>
          <p className="text-text-light">
            Explore user voting activity, engagement distributions, and trends.
          </p>
        </div>

        {/* Activity Overview - Votes Over Time & Recent Activity */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <VotesOverTime />
          <RecentActivity />
        </div>

        {/* Distribution Statistics */}
        <div>
          <h2
            className="font-serif text-xl font-semibold mb-4"
            style={{ color: '#1A1A1A' }}
          >
            Engagement Distributions
          </h2>
          <DistributionStats />
        </div>

        {/* Pairwise Coverage Matrix */}
        <div>
          <h2
            className="font-serif text-xl font-semibold mb-4"
            style={{ color: '#1A1A1A' }}
          >
            Pairwise Vote Coverage
          </h2>
          <PairwiseCoverageMatrix />
        </div>

        {/* Users Table with Filters */}
        <div>
          <h2
            className="font-serif text-xl font-semibold mb-4"
            style={{ color: '#1A1A1A' }}
          >
            User Details
          </h2>
          <UsersAnalyticsTable />
        </div>
      </div>
    </EvalLayout>
  );
}
